// extracted by mini-css-extract-plugin
export default {"title":"pkOOiy0EYT","items":"wNSPk1rTR0","item":"fhUbVYgXnb","itemTextContainer":"kyvH1mxLB_","itemLabel":"o4lFWc8XTZ","itemSubtext":"hGzSCIJ9Wv"};